import { ExclamationCircleOutlined, LoginOutlined } from '@ant-design/icons'
import { ApolloError } from '@apollo/client'
import { useRedirect } from '@mbfab/frontend-common'
import { Button, Result, Space, Typography } from 'antd'
import posthog from 'posthog-js'
import { useEffect } from 'react'

import { routes } from '../../config/routes'

const { Text, Paragraph } = Typography

export const ErrorPage: React.FC<{ error: unknown }> = ({ error }) => {
  const redirect = useRedirect()
  useEffect(() => {
    posthog.captureException(error) // エラートラッキングはBugsnagでやっているが、一応posthogでもやっておく
  }, [error])

  const errorText = error instanceof Error ? error.message : null
  const getActions = () => {
    if (!(error instanceof ApolloError)) {
      return []
    }
    const graphQLError = error.graphQLErrors[0]
    if (graphQLError === undefined) {
      return []
    }
    const errorCode = graphQLError.extensions?.code
    // TODO: エラーが起きた際のアクションを最適化できていない（そもそも、基本的にはエラーは発生しないはず？）
    switch (errorCode) {
      case 'UNAUTHENTICATED': {
        return [
          {
            message: 'ログイン画面へ',
            onClick: () => {
              redirect(routes.signOutPath())
            },
          },
        ]
      }
      case 'FORBIDDEN': {
        return [
          {
            message: `トップページへ`,
            onClick: () => {
              redirect(routes.tenantSelectPath())
            },
          },
          {
            message: `画面の再読み込み`,
            onClick: () => {
              window.location.reload()
            },
          },
        ]
      }
      case 'NOT_FOUND': {
        return [
          {
            message: `トップページへ`,
            onClick: () => {
              redirect(routes.signOutPath())
            },
          },
        ]
      }
      case 'VALIDATION_ERROR': {
        return [
          {
            message: `トップページへ`,
            onClick: () => {
              redirect(routes.tenantSelectPath())
            },
          },
          {
            message: `画面の再読み込み`,
            onClick: () => {
              window.location.reload()
            },
          },
        ]
      }
      case 'CONFLICT': {
        return [
          {
            message: `トップページへ`,
            onClick: () => {
              redirect(routes.tenantSelectPath())
            },
          },
          {
            message: `画面の再読み込み`,
            onClick: () => {
              window.location.reload()
            },
          },
        ]
      }
      case 'UNPROCESSABLE_ENTITY': {
        return [
          {
            message: `トップページへ`,
            onClick: () => {
              redirect(routes.tenantSelectPath())
            },
          },
          {
            message: `画面の再読み込み`,
            onClick: () => {
              window.location.reload()
            },
          },
        ]
      }
    }
    return [
      {
        message: `ログイン画面へ`,
        onClick: () => {
          redirect(routes.signOutPath())
        },
      },
      {
        message: `画面の再読み込み`,
        onClick: () => {
          window.location.reload()
        },
      },
    ]
  }
  const actions = getActions()

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
      <Result
        status="error"
        icon={<ExclamationCircleOutlined className="text-red-500" />}
        title={`エラーが発生しました`}
        subTitle={errorText}
        extra={
          <Space direction="vertical" size="middle" className="w-full mt-4">
            {actions.map((action) => (
              <Button
                key={action.message}
                // type="primary"
                icon={<LoginOutlined />}
                size="large"
                block
                onClick={action.onClick}
              >
                {action.message}
              </Button>
            ))}
          </Space>
        }
      />
    </div>
  )
}
